module.exports = __webpack_public_path__ + "static/media/keyboard_icon_white.9804e1e1.svg";